module.exports = "<p>\n  invitation-codes works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/beta-codes/invitation-codes/invitation-codes.component.html
// module id = ./src/app/beta-codes/invitation-codes/invitation-codes.component.html
// module chunks = main